export { default as SerpStoreClosureSlot } from './SerpStoreClosureSlot';
